export enum SourceFilterEnum {
  all = '',
  ynet = 'ynet',
  walla = 'walla',
  mda = 'twitter',
  critical = 'critical'
}
